'use client';
import NiceModal from '@ebay/nice-modal-react';
import { IS_CLIENT } from '@repo/common-utils';
import { usePageNavigationEvent, useAppRouterAdapter, useWorkingPlatform, RouterProvider, WorkingPlatform, useUTM, useBznavAppVersion } from '@repo/platform';
import { EventTrackingProvider } from '@repo/tracking-service';
import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, DialogProvider } from '@repo/ui';
import { ReactNode } from 'react';

import { GlobalErrorBoundary } from '@/app/_components/GlobalErrorBoundary';

export const BrandAppContents = ({ children, serverWorkingPlatform }: { children: ReactNode; serverWorkingPlatform: WorkingPlatform }) => {
  const router = useAppRouterAdapter();
  const navigationEvent = usePageNavigationEvent();
  const { workingPlatform, updateWorkingPlatform } = useWorkingPlatform();
  useUTM();

  if (!IS_CLIENT) {
    updateWorkingPlatform(serverWorkingPlatform || workingPlatform);
  }

  return (
    <RouterProvider router={router}>
      <EventTrackingProvider
        appId={'bznav-brand'}
        clientId={`bznav-brand-${workingPlatform}`}
        navigationEvent={navigationEvent}
        isUseAuthPackages={false}
        mixpanelProps={{
          mixpanelKey: process.env.NEXT_PUBLIC_MIXPANEL_KEY
        }}
      >
        <DialogProvider>
          <PageContent>{children}</PageContent>
        </DialogProvider>
      </EventTrackingProvider>
    </RouterProvider>
  );
};

const PageContent = ({ children }: { children: ReactNode }) => {
  useBznavAppVersion();

  return (
    <GlobalErrorBoundary>
      <NiceModal.Provider>{children}</NiceModal.Provider>
    </GlobalErrorBoundary>
  );
};

export const PageNotFoundHomeButton = () => {
  const { sendClickEvent } = useUserEventLogger();

  return (
    <BoxButton variant={'filled-primary'} size={'medium'} onClick={() => sendClickEvent('go-to-home')}>
      홈으로 돌아가기
    </BoxButton>
  );
};
